__turbopack_context__.v({
  "aboutSection": "Footer-module-scss-module__S87mIa__aboutSection",
  "container": "Footer-module-scss-module__S87mIa__container",
  "copyright": "Footer-module-scss-module__S87mIa__copyright",
  "description": "Footer-module-scss-module__S87mIa__description",
  "footer": "Footer-module-scss-module__S87mIa__footer",
  "heading": "Footer-module-scss-module__S87mIa__heading",
  "link": "Footer-module-scss-module__S87mIa__link",
  "linkList": "Footer-module-scss-module__S87mIa__linkList",
  "linksColumn": "Footer-module-scss-module__S87mIa__linksColumn",
  "linksWrapper": "Footer-module-scss-module__S87mIa__linksWrapper",
  "mobileOnly": "Footer-module-scss-module__S87mIa__mobileOnly",
  "socialIcon": "Footer-module-scss-module__S87mIa__socialIcon",
  "socials": "Footer-module-scss-module__S87mIa__socials",
});
